var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.block.newsletter_type.length && _vm.block.newsletter_type[0] === 'with_text')?_c('Newsletter'):_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-24 col-md-12 NewsletterBlock__formWrapper"},[_c('NewsletterForm')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }